<template>
  <div v-if="lyrics">
    <button role="button" v-if="lyrics.canEdit" v-show="!editMode" @click="this.editMode = !this.editMode">
      Upraviť
    </button>

    <div v-show="!editMode">
      <LyricsText :lyrics="lyrics" />
    </div>

    <div v-if="editMode">
      <button @click="saveLyrics" role="button">Uložiť</button>
      <button role="button" v-if="lyrics.canEdit" @click="this.editMode = !this.editMode">
        Zrušiť
      </button>

      <ckeditor :editor="editor" v-model="editorText" :config="editConfig" :style="{ height: '300px' }"></ckeditor>

      <button @click="saveLyrics" role="button">Uložiť</button>
      <button role="button" v-if="lyrics.canEdit" @click="this.editMode = !this.editMode">
        Zrusiť
      </button>
    </div>
  </div>

  <div v-if="!lyrics">
    <InputHider :toggle-class="'lyrics'" :points-gained="40" :placeholder="'Pridaj popisok'">
      create
      <ckeditor :editor="editor" v-model="editorText" :config="createConfig"></ckeditor>
    </InputHider>
  </div>
</template>

<script>
import { lyricsConfig } from "../ckeditor/configs";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import InputHider from "../InputHider/InputHider.vue";
import LyricsText from "./LyricsText.vue";

export default {
  name: "Lyrics",
  components: { InputHider, LyricsText },
  props: {
    lyrics: Object,
  },
  watch: {
    editMode(edit) {
      this.editorText = edit ? this.lyrics.text : this.editorText;
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorText: '',
      createConfig: lyricsConfig,
      editConfig: lyricsConfig,
      lyrics: null,
      editMode: false,
    }
  },
  methods: {

  }
}
</script>
